import type { FaireProductEntity } from "../../entity_types/product";

export const p_qd2zpvpzse: FaireProductEntity = {
  token: "p_qd2zpvpzse",
  type: "product",
  name: "Smoke Candle",
  brandToken: "b_fyb6rnmnyf",
  brandName: "Putnam Design LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/c58df8459bc4e0eb799b7ab5a5d5a8e17ce332786c257f441114b038f503c18c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3da39a7e0e5917d99e26013424f5acdf5ad1fc6b7867f7293ce813f1a6908bb.jpeg",
    "https://cdn.faire.com/fastly/afebe488bb45ed032bef130d1fc6a84e07fb73102e6e8472c6544e2a80164f63.png",
  ],
  priceDollars: 20,
  description:
    "Single note scented candle hand-poured and crafted in Los Angeles exclusively by Putnam Design.\n\n• 9 oz of Soy wax\n• 40 hour burn time\n• Trim wick before each use",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:24.929Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
